import { Component, OnInit } from '@angular/core';
import { ToastService } from '@app/shared/services/toast.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromSharedStore from 'src/app/shared/store';

@Component({
  selector: 'app-toast-list',
  templateUrl: './toast-list.component.html',
  styleUrls: ['./toast-list.component.scss'],
})
export class ToastListComponent implements OnInit {
  toasts$: Observable<any>;

  constructor(
    private sharedStore: Store<fromSharedStore.State>,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.toasts$ = this.sharedStore.select(fromSharedStore.getToastMessages);
  }

  deleteToast(toast: any) {
    this.toastService.deleteToast(toast);
  }
}
